<template>
    <div class="container-fluid">
        <Breadcrumb title="Create Unsubscriber" v-bind:button-show="false"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12 row-preloader">
                <Preloader v-bind:class="{preloader: loading}" v-show="loading"></Preloader>
            </div>
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <UnsubscriberForm @hidePreloader="hidePreloader"></UnsubscriberForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Preloader from '../components/Preloader';
    import UnsubscriberForm from './forms/UnsubscriberForm';
    import Breadcrumb from '../components/Breadcrumb';

    export default {
        name: 'Unsubscriber',
        components: {
            Preloader, UnsubscriberForm, Breadcrumb
        },
        data() {
            return {
                loading: false,
            }
        },
        mounted() {
            if (this.$route.params.id) {
                this.loading = true;
            }
        },
        methods: {
            hidePreloader(value) {
                this.loading = value
            }
        }
    }
</script>

<style scoped>

</style>